// extracted by mini-css-extract-plugin
export var modalFooter = "_m8-0";